export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-selection/src/constant.js
// module id = LpLG
// module chunks = 0